// extracted by mini-css-extract-plugin
export default {"root":"EditorHeader__root--1uzt5","adIcon":"EditorHeader__adIcon--28aZk","emptyShareLink":"EditorHeader__emptyShareLink--2w2-T","license":"EditorHeader__license--1i7y5"};